module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8.0a77f614.png";